import script from "./TabPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TabPage.vue?vue&type=script&setup=true&lang=js"

import "./TabPage.vue?vue&type=style&index=0&id=a9216ba4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9216ba4"]])

export default __exports__